import i18n from '@/locales'

export const rateLimitingIntervalOptions = [
  {
    value: 60,
    label: i18n.t('common_168'),
  },
  {
    value: 60 * 5,
    label: i18n.t('common_169'),
  },
  {
    value: 60 * 30,
    label: i18n.t('common_172'),
  },
  {
    value: 60 * 60,
    label: i18n.t('common_173'),
  },
]

export const cacheTtlOptions = [
  {
    value: 60,
    label: i18n.t('common_168'),
  },
  {
    value: 60 * 5,
    label: i18n.t('common_169'),
  },
  {
    value: 60 * 30,
    label: i18n.t('common_172'),
  },
  {
    value: 60 * 60,
    label: i18n.t('common_173'),
  },
  {
    value: 60 * 60 * 24,
    label: i18n.t('durations.1d'),
  },
  {
    value: 60 * 60 * 24 * 7,
    label: i18n.t('durations.1w'),
  },
  {
    value: 2628288,
    label: i18n.t('compute.text_143'),
  },
]
